import { render, staticRenderFns } from "./CollateralPrice.vue?vue&type=template&id=745612d5&scoped=true"
import script from "./CollateralPrice.vue?vue&type=script&lang=js"
export * from "./CollateralPrice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "745612d5",
  null
  
)

export default component.exports